import { HttpTypes } from "@medusajs/types"

export type AdminUserRole = "admin" | "member"

/**
 * Reads the admin role from `user.metadata.role`. Users without an assigned
 * role are treated as admins (legacy behavior, mirrored by the backend guards).
 */
export const getAdminUserRole = (
  user?: HttpTypes.AdminUser | null
): string => {
  const role = user?.metadata?.role
  return typeof role === "string" && role.trim()
    ? role.toLowerCase().trim()
    : "admin"
}

export const isUserManagementAdmin = (
  user?: HttpTypes.AdminUser | null
): boolean => ["admin", "super_admin"].includes(getAdminUserRole(user))

/**
 * Assigning roles needs an explicit admin/super_admin role; a role-less legacy
 * admin is refused by the backend (requireAdminUserManagement, F-15).
 */
export const canAssignAdminRoles = (
  user?: HttpTypes.AdminUser | null
): boolean => {
  const role = user?.metadata?.role
  return (
    typeof role === "string" &&
    ["admin", "super_admin"].includes(role.toLowerCase().trim())
  )
}
